export { default } from './forEachRight.js'



//////////////////
// WEBPACK FOOTER
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/lodash-es/eachRight.js
// module id = 227
// module chunks = 0